export const TeacherExamDetailTranslations = {
  EDIT_EXAM: {
    es: 'Editar examen',
    en: 'Edit exam',
    cat: 'Editar examen',
    eus: 'Examen editatu',
    pt: 'Editar prova'
  },
  PUT_SCORE: {
    es: 'Poner nota',
    en: 'Put score',
    cat: 'Poner nota',
    eus: 'Ezabatu',
    pt: 'Eliminar'
  },
  SAVE: {
    es: 'Guardar',
    en: 'Save',
    cat: 'Guardar',
    eus: 'Gorde',
    pt: 'Guardar'
  }
};
